import React from 'react'
import PropTypes from 'prop-types'

import { ListItem, ListItemText } from '@mui/material'

import HHDisplayMoney from 'components/common/HHDisplayMoney'

const SearchOptionRow = ({ leftPrimaryText = '', leftSecondaryText = '', rightPrimaryText = '', rightSecondaryText = '' }) => {
  return (
    <>
      <ListItem disablePadding sx={{ width: '75%' }}>
        <ListItemText
          primary={leftPrimaryText}
          secondary={leftSecondaryText}
          slotProps={{
            primary: { noWrap: true, variant: 'h5', fontWeight: 400 },
            secondary: { noWrap: true, variant: 'h6', fontWeight: 400 },
          }}
        />
      </ListItem>
      <ListItem disablePadding sx={{ textAlign: 'right', width: '25%' }}>
        <ListItemText
          primary={<HHDisplayMoney value={rightPrimaryText} />}
          secondary={rightSecondaryText}
          slotProps={{
            primary: { variant: 'h5', fontWeight: 400 },
            secondary: { variant: 'h6', fontWeight: 400 },
          }}
        />
      </ListItem>
    </>
  )
}

SearchOptionRow.propTypes = {
  leftPrimaryText: PropTypes.string,
  leftSecondaryText: PropTypes.string,
  rightPrimaryText: PropTypes.string,
  rightSecondaryText: PropTypes.string,
}

export default SearchOptionRow
